import React from 'react';

import {DocumentList, File} from 'components/documents';

export const DocumentInformation = ({ document }) => (
  <DocumentList>
    <File>Документ: <strong><a href={document.get('attachment')} target="_blank" style={{color: "#da9c15", textDecoration: "underline"}}>{document.get('name')}</a></strong></File>
    <li>Номер документа: <strong>{document.get('number')}</strong></li>
    <li>Автор документа: <strong>{document.get('author_data').get('last_name')} {document.get('author_data').get('first_name')}</strong></li>
  </DocumentList>
)



// WEBPACK FOOTER //
// ./src/operator/mailing/detail/document-information.js